import { SecurityScanResultEvidenceTypeEnum } from '@repo/api-gw-sdk';

const EVIDENCE_DISPLAY_NAMES = {
  [SecurityScanResultEvidenceTypeEnum.SuspiciousExtensionDetected]:
    'Files signature',
  [SecurityScanResultEvidenceTypeEnum.ModifiedFilesBecameEncrypted]:
    'Files content',
  [SecurityScanResultEvidenceTypeEnum.SuspiciousActivityDetected]:
    'Folders behavior',
  [SecurityScanResultEvidenceTypeEnum.MalwareDetected]: 'Malware detected',
  [SecurityScanResultEvidenceTypeEnum.TableDeletion]: 'Table deletion',
  [SecurityScanResultEvidenceTypeEnum.SignificantRowDecrease]:
    'Significant row decrease between snapshots',
  [SecurityScanResultEvidenceTypeEnum.HighChangePercentage]:
    'High data bytes change percentage between snapshots',
  [SecurityScanResultEvidenceTypeEnum.DbRansomNoteTableName]:
    'Ransom note table name detected',
  [SecurityScanResultEvidenceTypeEnum.DbRansomNoteContent]:
    'Ransom note content detected',
  [SecurityScanResultEvidenceTypeEnum.KmsUnavailableResources]:
    'KMS unavailable resources',
  [SecurityScanResultEvidenceTypeEnum.SsecUnavailableResources]:
    'SSE-C encrypted objects',
  [SecurityScanResultEvidenceTypeEnum.MassFileDeleteAnomaly]:
    'Mass file deletion',
  [SecurityScanResultEvidenceTypeEnum.RansomwareNote]: 'Ransomware note',
  [SecurityScanResultEvidenceTypeEnum.AiSensitiveDataExposure]:
    'AI application with sensitive data',
  [SecurityScanResultEvidenceTypeEnum.AiSensitiveDataPublicExposure]:
    'Public AI application with sensitive data',
  [SecurityScanResultEvidenceTypeEnum.PublicSensitiveDataExposure]:
    'Publicly exposed sensitive data',
  [SecurityScanResultEvidenceTypeEnum.Php2shellVulnerableApplication]:
    'PHP vulnerable to PHP2Shell',
} satisfies Record<SecurityScanResultEvidenceTypeEnum, string>;

export const EVIDENCE_TYPE_OPTIONS = Object.entries(EVIDENCE_DISPLAY_NAMES).map(
  ([id, name]) => ({
    id,
    name,
  })
);

export const getEvidenceDisplayName = (evidenceType: string): string =>
  EVIDENCE_DISPLAY_NAMES[evidenceType as SecurityScanResultEvidenceTypeEnum] ||
  evidenceType;
